<template>
  <div class="relative mx-4 py-3">
    <div class="absolute inset-0 flex items-center">
      <div class="border-lightSecondaryColor dark:border-darkSecondaryColor w-full border-t"></div>
    </div>
    <div class="relative flex justify-center">
      <span
        class="bg-lightSecondaryColor text-lightSecondaryTextColor dark:bg-darkPrimaryColor dark:text-darkSecondaryTextColor px-3 text-xs font-medium"
      >
        {{ label }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
}

defineProps<Props>();
</script>
